export const ROLE_PERMISSIONS = {
  superuser: [
    'settings',
    'settings.users',
    'settings.users.add',
    'settings.users.edit',
    'settings.users.delete',
  ],
};

export const ALL_ROLES = Object.keys(ROLE_PERMISSIONS);

export const hasPermission = (userRoles, permission) => {
  if (!userRoles || !Array.isArray(userRoles)) return false;
  for (const role of userRoles) {
    const permissions = ROLE_PERMISSIONS[role];
    if (permissions && permissions.includes(permission)) {
      return true;
    }
  }
  return false;
};
